export default __webpack_public_path__ + "static/media/Dip Drop Stop Dip.ecafd61a.mp3";